import { FC } from "react";
import { IconPropsType } from ".";

export const EyeSlash: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 3.72379C6.38497 3.72379 4.79321 4.88497 3.74255 5.85923C3.27007 6.30006 2.82637 6.76922 2.41406 7.26398C2.81081 7.73975 3.23646 8.19197 3.68873 8.61822C4.75152 9.61513 6.36412 10.8042 8 10.8042C9.61503 10.8042 11.2068 9.64298 12.2575 8.66872C12.7299 8.2279 13.1736 7.75873 13.5859 7.26398C13.1892 6.7882 12.7635 6.33598 12.3113 5.90974C11.2485 4.91282 9.63588 3.72379 8 3.72379ZM8 1.83569C12.4184 1.83569 16 7.26398 16 7.26398C16 7.26398 12.4184 12.6923 8 12.6923C3.58158 12.6923 0 7.26398 0 7.26398C0 7.26398 3.58158 1.83569 8 1.83569Z"
        fill={props.color || "#CACACA"}
      />
      <path
        d="M8.00006 9.38809C9.20504 9.38809 10.1819 8.43709 10.1819 7.26398C10.1819 6.09086 9.20504 5.13987 8.00006 5.13987C6.79507 5.13987 5.81824 6.09086 5.81824 7.26398C5.81824 8.43709 6.79507 9.38809 8.00006 9.38809Z"
        fill={props.color || "#CACACA"}
      />
      <path
        d="M1.83619 15L0.440796 13.6887L14.0166 0L15.4119 1.31128L1.83619 15Z"
        fill={props.color || "#CACACA"}
      />
    </svg>
  );
};
